import React, { useState } from 'react'
import { ApplicationModal } from 'state/application/actions'
import { useModalOpen, useToggleSelectBadgeModal } from 'state/application/hooks'
import Modal from '../../components/Modal'
import {
  Wrapper,
  Button,
  BadgeLabel,
  BadgeTitle,
  BadgePrice,
  BuyButton,
  AmountInfo,
  BadgeHeaderWrapper
} from './styled'
// import Badge from '../../assets/images/badges/badge.png'

const Index = () => {
  const badgeModalOpen = useModalOpen(ApplicationModal.BADGE)
  const toggleBadgeModal = useToggleSelectBadgeModal()
  const [badgeAmount, setBadgeAmount] = useState(1)

  return (
    <Modal isOpen={badgeModalOpen} onDismiss={toggleBadgeModal} width={30} minHeight={false} maxHeight={90}>
      <Wrapper>
        <div>
          <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
            <div>
              <img loading="lazy" src="https://boxycats.web.app/static/media/yudicats.548b6140.gif" alt="yudi punya" />
            </div>
            <BadgeHeaderWrapper>
              <BadgeTitle>Yield Guild Badge</BadgeTitle>
              <BadgePrice>$110,00</BadgePrice>
            </BadgeHeaderWrapper>
          </div>
          <div style={{ display: 'flex', marginTop: '30px' }}>
            <Button
              onClick={() => {
                if (badgeAmount === 0) return
                setBadgeAmount(prev => prev - 1)
              }}
            >
              -
            </Button>
            <BadgeLabel>{badgeAmount} Badge</BadgeLabel>
            <Button onClick={() => setBadgeAmount(prev => prev + 1)}>+</Button>
          </div>
          <AmountInfo>
            <div style={{ opacity: 0.6 }}>Total Amount</div>
            <div
              style={{
                fontWeight: 500,
                fontSize: '16px'
              }}
            >
              {badgeAmount * 0.012} ETH
            </div>
          </AmountInfo>
          <BuyButton>Confirm Buy</BuyButton>
        </div>
      </Wrapper>
    </Modal>
  )
}

export default Index
